
{
  "familyId": "TIJD-TIJDZONES",
  "questions": [
    {
      "id": "TIJD-TIJDZONES-001",
      "familyId": "TIJD-TIJDZONES",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "klokkijken",
      "subSkill": "klok_tijdzones",
      "questionType": "multiple_choice",
      "question": "In Nederland is het 14:00 uur. In New York is het 6 uur eerder. Hoe laat is het in New York?",
      "options": ["08:00", "20:00", "06:00", "12:00"],
      "correctAnswer": 0,
      "conceptId": "tijdzones_eerder",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "context": "Tijdverschil met New York",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.timezone-direction-confused", "label": "Optellen ipv aftrekken", "optionIndex": 1 }
        ]
      },
      "stimulusAids": [
        {
          "type": "worldClockPanel",
          "showWhen": "always",
          "data": {
            "clocks": [
              { "city": "Nederland", "time": "14:00", "utcOffset": 1, "isReference": true },
              { "city": "New York", "time": "??:??", "utcOffset": -5 }
            ],
            "label": "Tijdzone: Nederland → New York (−6 uur)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "worldClockPanel",
          "showWhen": "wrong",
          "data": {
            "clocks": [
              { "city": "Nederland", "time": "14:00", "utcOffset": 1, "isReference": true },
              { "city": "New York", "time": "08:00", "utcOffset": -5 }
            ],
            "label": "Als een stad 'eerder' is, trek je uren af. 14:00 − 6 = 08:00."
          }
        }
      ],
      "feedback": {
        "explanationText": "New York is 6 uur eerder dan Nederland. 'Eerder' = aftrekken. 14:00 − 6 = 08:00.",
        "solutionSteps": [
          "New York is 6 uur eerder",
          "14:00 − 6 = 08:00"
        ],
        "distractorExplanations": {
          "0": "Goed! 14:00 − 6 = 08:00.",
          "1": "Je dacht waarschijnlijk dat je moest optellen. Maar 'eerder' betekent aftrekken. Als het in New York eerder is, is de klok daar achter. Onthoud: eerder = aftrekken.",
          "2": "Je hebt de 6 uur als tijd gelezen, niet als verschil. 14:00 − 6 uur = 08:00, niet 06:00. Onthoud: trek het verschil af van de huidige tijd.",
          "3": "Je dacht waarschijnlijk dat je 2 uur moest aftrekken. Maar het verschil is 6 uur: 14:00 − 6 = 08:00. Onthoud: lees het tijdverschil goed."
        }
      }
    },
    {
      "id": "TIJD-TIJDZONES-002",
      "familyId": "TIJD-TIJDZONES",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "klokkijken",
      "subSkill": "klok_tijdzones",
      "questionType": "multiple_choice",
      "question": "In Nederland is het 22:00 uur. In Tokio is het 8 uur later. Hoe laat is het in Tokio?",
      "options": ["06:00 (volgende dag)", "14:00", "30:00", "06:00 (dezelfde dag)"],
      "correctAnswer": 0,
      "conceptId": "tijdzones_over_middernacht",
      "variantIndex": 2,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.71,
      "context": "Tijdverschil met Tokio over middernacht",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.timezone-direction-confused", "label": "Aftrekken ipv optellen", "optionIndex": 1 },
          { "id": "tijd.timezone-midnight-error", "label": "Geen 24u correctie", "optionIndex": 2 }
        ]
      },
      "stimulusAids": [
        {
          "type": "worldClockPanel",
          "showWhen": "always",
          "data": {
            "clocks": [
              { "city": "Nederland", "time": "22:00", "utcOffset": 1, "isReference": true },
              { "city": "Tokio", "time": "??:??", "utcOffset": 9 }
            ],
            "label": "Tijdzone: Nederland → Tokio (+8 uur)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "worldClockPanel",
          "showWhen": "wrong",
          "data": {
            "clocks": [
              { "city": "Nederland", "time": "22:00", "utcOffset": 1, "isReference": true },
              { "city": "Tokio", "time": "06:00", "utcOffset": 9 }
            ],
            "label": "22:00 + 8 = 30 uur. Een dag heeft 24 uur: 30 − 24 = 06:00 de volgende dag."
          }
        }
      ],
      "feedback": {
        "explanationText": "22:00 + 8 = 30. Maar een dag heeft maar 24 uur. 30 − 24 = 6. Het is 06:00 de volgende dag in Tokio.",
        "solutionSteps": [
          "22:00 + 8 = 30",
          "30 − 24 = 6 → 06:00 volgende dag"
        ],
        "distractorExplanations": {
          "0": "Goed! 22 + 8 = 30, en 30 − 24 = 6. Het is 06:00 de volgende dag.",
          "1": "Je dacht waarschijnlijk dat je moest aftrekken. Maar Tokio is later, dus je telt op. 22 + 8 = 30 → 06:00 volgende dag. Onthoud: later = optellen.",
          "2": "30:00 bestaat niet! Een dag heeft 24 uur. Als je boven 24 komt, trek je 24 af: 30 − 24 = 06:00 volgende dag.",
          "3": "Het is inderdaad 06:00, maar de volgende dag — niet dezelfde dag. Als je over middernacht gaat, ben je een dag verder."
        }
      }
    },
    {
      "id": "TIJD-TIJDZONES-003",
      "familyId": "TIJD-TIJDZONES",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "klokkijken",
      "subSkill": "klok_tijdzones",
      "questionType": "multiple_choice",
      "question": "Welke uitspraak over tijdzones is juist?",
      "options": ["In het oosten is het later dan in het westen", "In het westen is het later dan in het oosten", "Alle landen in Europa hebben dezelfde tijd", "Tijdzones veranderen elk seizoen"],
      "correctAnswer": 0,
      "conceptId": "tijdzones_begrip",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "context": "Begrip van tijdzones",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "tijd.timezone-direction-confused", "label": "Oost en west verward", "optionIndex": 1 }
        ]
      },
      "stimulusAids": [
        {
          "type": "worldClockPanel",
          "showWhen": "always",
          "data": {
            "clocks": [
              { "city": "New York (West)", "time": "08:00", "utcOffset": -5 },
              { "city": "Londen", "time": "13:00", "utcOffset": 0, "isReference": true },
              { "city": "Tokio (Oost)", "time": "22:00", "utcOffset": 9 }
            ],
            "label": "Tijdzones: west → oost"
          }
        }
      ],
      "supportAids": [
        {
          "type": "worldClockPanel",
          "showWhen": "wrong",
          "data": {
            "clocks": [
              { "city": "New York (West)", "time": "08:00", "utcOffset": -5 },
              { "city": "Londen", "time": "13:00", "utcOffset": 0, "isReference": true },
              { "city": "Tokio (Oost)", "time": "22:00", "utcOffset": 9 }
            ],
            "label": "De zon komt op in het oosten. Daarom is het in het oosten eerder licht en dus later op de klok."
          }
        }
      ],
      "feedback": {
        "explanationText": "De zon komt op in het oosten. Landen in het oosten (zoals Japan) zien de zon eerder dan landen in het westen (zoals Amerika). Daarom is het in het oosten later op de klok.",
        "solutionSteps": [
          "De zon komt op in het oosten",
          "Oosten = eerder licht = later op de klok"
        ],
        "distractorExplanations": {
          "0": "Goed! De zon komt op in het oosten, dus daar is het later op de klok.",
          "1": "Je verwisselde oost en west. De zon komt op in het oosten, dus daar is het eerder licht en later op de klok. Onthoud: oost = later.",
          "2": "Niet alle Europese landen hebben dezelfde tijd. Portugal en Griekenland hebben bijvoorbeeld een ander tijdverschil. Onthoud: Europa heeft meerdere tijdzones.",
          "3": "Tijdzones veranderen niet per seizoen. Wel kan de zomertijd/wintertijd veranderen, maar de tijdzone zelf blijft gelijk."
        }
      }
    },
    {
      "id": "TIJD-TIJDZONES-004",
      "familyId": "TIJD-TIJDZONES",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "klokkijken",
      "subSkill": "klok_tijdzones",
      "questionType": "multiple_choice",
      "question": "Een piloot vertrekt om 10:00 uit Amsterdam. De vlucht duurt 9 uur. In Dubai is het 3 uur later dan in Amsterdam. Hoe laat landt hij in Dubai?",
      "options": ["22:00", "19:00", "16:00", "01:00"],
      "correctAnswer": 0,
      "conceptId": "tijdzones_vlucht",
      "variantIndex": 4,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.69,
      "context": "Vliegtijd en tijdzone",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.timezone-flight-error", "label": "Tijdverschil vergeten", "optionIndex": 1 }
        ]
      },
      "stimulusAids": [
        {
          "type": "worldClockPanel",
          "showWhen": "always",
          "data": {
            "clocks": [
              { "city": "Amsterdam", "time": "19:00", "utcOffset": 1, "isReference": true },
              { "city": "Dubai", "time": "??:??", "utcOffset": 4 }
            ],
            "label": "Aankomsttijd na 9 uur vliegen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "worldClockPanel",
          "showWhen": "wrong",
          "data": {
            "clocks": [
              { "city": "Amsterdam", "time": "19:00", "utcOffset": 1, "isReference": true },
              { "city": "Dubai", "time": "22:00", "utcOffset": 4 }
            ],
            "label": "Aankomst Amsterdam = 10:00 + 9 = 19:00. Dubai is 3 uur later: 19:00 + 3 = 22:00."
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: Aankomsttijd in Nederlandse tijd = 10:00 + 9 uur = 19:00. Stap 2: Dubai is 3 uur later: 19:00 + 3 = 22:00 lokale tijd in Dubai.",
        "solutionSteps": [
          "Vertrek 10:00 + 9 uur vlucht = 19:00 (NL-tijd)",
          "Dubai is 3 uur later: 19:00 + 3 = 22:00"
        ],
        "distractorExplanations": {
          "0": "Goed! 10:00 + 9 = 19:00 NL-tijd, + 3 uur tijdverschil = 22:00 Dubai-tijd.",
          "1": "Je bent vergeten het tijdverschil op te tellen. 19:00 is de aankomsttijd in Nederlandse tijd, maar in Dubai is het 3 uur later: 19:00 + 3 = 22:00.",
          "2": "Je hebt alleen de vliegtijd opgeteld zonder het tijdverschil. 10:00 + 6 = 16:00 klopt niet. Reken: 10 + 9 + 3 = 22:00.",
          "3": "Je hebt 10 + 9 + 3 = 22 goed berekend, maar 01:00 zou betekenen dat je over middernacht gaat. 22:00 is nog dezelfde dag."
        }
      }
    },
    {
      "id": "TIJD-TIJDZONES-005",
      "familyId": "TIJD-TIJDZONES",
      "module": "Tijd",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "klokkijken",
      "subSkill": "klok_tijdzones",
      "questionType": "fill_in",
      "question": "In Nederland is het 15:00. In Sydney is het 9 uur later. Hoe laat is het in Sydney? Typ in 24-uursnotatie (bijv. 08:00).",
      "data": {
        "acceptedAnswers": ["00:00", "0:00", "24:00"],
        "caseSensitive": false,
        "placeholder": "??:??"
      },
      "correctAnswer": "00:00",
      "conceptId": "tijdzones_middernacht_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "context": "Tijdverschil met Sydney over middernacht",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "worldClockPanel",
          "showWhen": "always",
          "data": {
            "clocks": [
              { "city": "Nederland", "time": "15:00", "utcOffset": 1, "isReference": true },
              { "city": "Sydney", "time": "??:??", "utcOffset": 10 }
            ],
            "label": "Tijdzone: Nederland → Sydney (+9 uur)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "worldClockPanel",
          "showWhen": "wrong",
          "data": {
            "clocks": [
              { "city": "Nederland", "time": "15:00", "utcOffset": 1, "isReference": true },
              { "city": "Sydney", "time": "00:00", "utcOffset": 10 }
            ],
            "label": "15:00 + 9 = 24:00 = 00:00 (middernacht). Als je precies op 24 uitkomt, is het middernacht."
          }
        }
      ],
      "feedback": {
        "explanationText": "15:00 + 9 = 24:00. 24:00 is hetzelfde als 00:00 (middernacht). Het is middernacht in Sydney.",
        "solutionSteps": [
          "15:00 + 9 uur = 24:00",
          "24:00 = 00:00 (middernacht)"
        ],
        "distractorExplanations": {}
      }
    }
  ]
}
